import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-deleted-file-icon',
  templateUrl: './files-deleted-file.component.html'
})
export class FilesDeletedFileComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
